<template>
  <vd-page-dialog :back-link="innerBackLink" class="notifications-page" title="Notifications" :loading="loading">
    <template v-if="error">Sorry an error occurred while fetching the notifications.</template>
    <template v-else-if="notifications.length > 0">
      <VdCard
        v-for="(notification, index) in notifications"
        :key="notification.date"
        class="notif-card"
        expandable
        :expanded="index === 0"
      >
        <h2 class="notif-title">
          <span>{{ notification.version }} • {{ notification.title }}</span>
          <el-tag>{{ formatDate(notification.date) }}</el-tag>
        </h2>
        <template #expanded-content>
          <div class="notification-page-content" v-html="marked(notification.content)"></div>
        </template>
      </VdCard>
    </template>
    <template v-else>There is no notifications to show for now</template>
  </vd-page-dialog>
</template>

<script lang="ts">
import { VdCard } from "@voodoo.io/voodoo-ui";
import { parseISO, format } from "date-fns";
import marked from "marked";
import { computed, defineComponent, nextTick, onUnmounted, inject, Ref } from "vue";
import { RouteLocationRaw, useRoute } from "vue-router";

import { LAST_NOTIFICATION_ID_SEEN } from "@/constants";
import { useNotificationsPageQuery } from "@/graphql/generated-types";
import links from "@/router/links";

export default defineComponent({
  name: "NotificationsPage",

  components: {
    VdCard,
  },

  setup() {
    const route = useRoute();
    const { result, loading, error } = useNotificationsPageQuery();

    const notifications = computed(() => result.value?.notifications ?? []);

    const lastNotificationId = computed(() => (notifications.value.length ? notifications.value[0].id : ""));

    const lastNoficationIdSeen = inject<Ref<string>>(LAST_NOTIFICATION_ID_SEEN);

    onUnmounted(async () => {
      await nextTick();
      if (lastNoficationIdSeen) {
        lastNoficationIdSeen.value = lastNotificationId.value;
      }
    });

    const innerBackLink = computed<RouteLocationRaw>(() => {
      if (route.query.back && !Array.isArray(route.query.back)) {
        return route.query.back;
      }
      return { name: links.games.list };
    });

    const formatDate = (date: string) => format(parseISO(date), "eee dd MMM yyyy");

    return {
      error,
      notifications,
      loading,
      innerBackLink,
      formatDate,
      marked,
    };
  },
});
</script>

<style lang="scss">
.notifications-page {
  img {
    max-width: 100%;
    height: auto;
  }

  .notification-page-content {
    h1,
    h2,
    h3,
    h4,
    h5 {
      margin-bottom: size("ML");
      font-weight: bold;
    }
  }

  .notif-card {
    margin-bottom: size("L");

    .notif-title {
      display: flex;
      justify-content: space-between;
    }
  }

  .vd-page-component .body {
    margin-top: 0;
  }
}
</style>
